// extracted by mini-css-extract-plugin
module.exports = {"relative":"button__relative___3iutl","a11y-visible":"button__a11y-visible___38A3K","a11y-invisible":"button__a11y-invisible___3Tq4h"};